import { useState } from "react";
import { logExport } from "../domain/common/services/log.service";

export function useDownloadLog() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleLog(exportReason: string, filename: string, length: number) {
    if (!exportReason.trim() || !filename || !length) {
      return alert("필수 정보가 입력되지 않았습니다.");
    }
    
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      // 추출 사유를 서버에 보내는 API 호출
      await logExport(exportReason, filename, length);
    } catch (error) {
      console.error("Export log API error:", error);
    } finally {
      setIsSubmitting(false);
    }
  }

  return {
    handleLog,
    isSubmitting
  };
}